import gql from 'graphql-tag';

export const UpdateDraftByTemplateMutation =
	// eslint-disable-next-line graphql-relay-compat/no-experimental-directives -- Read http://go/cfe-no-experimental-directives
	gql`
		mutation UpdateDraftByTemplateMutation(
			$contentId: String!
			$spaceKey: String!
			$blueprint: String!
			$parentPageId: String
			$title: String
		) @experimental {
			experimentalUpdateDraftWithTemplate(
				spaceKey: $spaceKey
				contentId: $contentId
				blueprint: $blueprint
				parentPageId: $parentPageId
				title: $title
			) {
				content {
					id
					type
					title
					space {
						id
						key
					}
					_links {
						editui
					}
					metadata {
						properties {
							editor {
								value
							}
						}
					}
				}
			}
		}
	`;
